import { Outlet } from "react-router-dom";

function AdminLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default AdminLayout;